import api from "@/api";
const app = {
  state: {
    regions: [],
    stations: [],
    company: [],
    isMobile: null,
  },
  mutations: {
    SET_REGIONS(state, regions) {
      state.regions = regions;
    },
    SET_STATION(state, stations) {
      state.stations = stations;
    },
    SET_COMPANY(state, company) {
      state.company = company;
    },

    SET_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    },
  },
  actions: {
    async fetchRegions({ state, commit }) {
      if (!state.regions.length) {
        const response = await api.getAreaTree();
        if (!response.code) {
          commit("SET_REGIONS", response.data);
        }
      }
    },

    async fetchStations({ state, commit }) {
      if (!state.stations.length) {
        const response = await api.getStationNames();
        if (!response.code) {
          commit("SET_STATION", response.data);
        }
      }
    },

    async fetchCompany({ state, commit }) {
      if (!state.company.length) {
        const response = await api.getCompany();
        if (!response.code) {
          commit("SET_COMPANY", response.data);
        }
      }
    },
  },
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js